import { Component, Input, OnDestroy, OnInit, SecurityContext, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Banner } from 'src/@omnial/_models/catalog/banner.model';
import { Slider } from 'src/@omnial/_models/catalog/slider.model';
import { SevenSpikesService } from 'src/@omnial/_services/catalog/seven.spikes.service';
import { AppSettings } from 'src/app/app.settings';
import { SwiperOptions } from 'swiper/types';

@Component({
    selector: 'app-banners',
    templateUrl: './../../../app/shared/banners/banners.component.html',
    styleUrls: ['./../../../app/shared/banners/banners.component.scss'],
    standalone: false
})
export class BannersComponent implements OnDestroy, OnInit {
  @Input() widgetZone: string;
  @Input() sliderId: number;
  @Input() slug: string;
  @Input() sliderIndex: number = 0;
  @Input() contentClass: string = '';
  public config: SwiperOptions = null;
  public banners: Banner[];
  public banner: Banner;
  public arrowsOutside = false;
  public fullHold = '/assets/banners/fullHold.jpg';
  public largeHold = '/assets/banners/largeHold.jpg';
  public medHold = '/assets/banners/medHold.jpg';
  public smallHold = '/assets/banners/smallHold.jpg';
  public subscriptions: Subscription[] = [];

  constructor(private sevenSpikesService: SevenSpikesService,
    public router: Router,
    public settings: AppSettings,
    public sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.subscriptions.push(this.getSlides().subscribe(
      data => {
        const sliders = data as Slider[];
        if (sliders?.length > this.sliderIndex) {
          const slider = sliders[this.sliderIndex]; // We are only interested in one slider
          this.banners = new Array<Banner>();
          if (slider.slides) {
            slider.slides.forEach(slide => {
              if (slide.visible) {
                this.banners.push(this.sevenSpikesService.banner(slide));
              }
            });
          }
          if (this.banners?.length === 1) {
            this.banner = this.banners[0];
          }
          const contentSlide = slider.slides.find(slide => !slide.desktopImageUrl && slide.content);
          let navigation: any = slider.arrows;
          if (contentSlide && navigation) {
            this.arrowsOutside = true;
            navigation = {
              nextEl: '.swiper-button-next-banner',
              prevEl: '.swiper-button-prev-banner'
            };
          }
          let effect: "slide" | "fade" | "cube" | "coverflow" | "flip" = 'slide';
          if (sliders[this.sliderIndex]?.customClass?.toLowerCase() == 'flip') {
            effect = 'flip';
          } else if (sliders[this.sliderIndex]?.customClass?.toLowerCase() === 'cube') {
            effect = 'cube';
          } else if (sliders[this.sliderIndex]?.customClass?.toLowerCase() === 'coverflow') {
            effect = 'coverflow';
          } else if (sliders[this.sliderIndex]?.customClass?.toLowerCase() === 'fade') {
            effect = 'fade';
          } else if (slider.fade) {
            effect = 'fade';
          }
          this.config = {
            resizeObserver: true,
            slidesPerView: 1,
            spaceBetween: 0,
            grabCursor: false,
            loop: true,
            effect: effect,
            speed: slider.speed,
            autoplay: slider.autoplay ? { delay: slider.autoplaySpeed } : false,
            navigation: navigation,
            pagination: slider.dots
          }
        }
      }));
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => { sub.unsubscribe(); });
    }
  }

  public getSlides(): Observable<Slider[]> {
    if (this.widgetZone) {
      return this.sevenSpikesService.getSlides(this.widgetZone, this.slug);
    }
    if (this.sliderId) {
      return this.sevenSpikesService.getSlidesBySliderId(this.sliderId);
    }
  }

  public bannerLink(url: string): void {
    if (url && url !== null) {
      this.router.navigate([url]);
    }
  }
}
